<template>
  <ion-page>
    <ion-content>
      <ion-card style="box-shadow: none; display: flex; flex-direction: column; justify-content: space-between">
        <div>
          <ion-card-header>
            <PageNavigation page-precedente="start" page-suivante="activitee2" :page-title="pageTitle" :show-left-arrow="false" :show-right-arrow="true" />
          </ion-card-header>

          <ion-card-content>
            <ion-text style="display: flex; flex-direction: column;">
              <div>
                <p>Ma classe se rendra au salon le
                  <input type="date" class="dateTimeSelection" v-model="dateSelection"> et aura
                  <input type="text" class="hourSelection" v-model="hourSelection"> heures sur place.
                </p>
              </div>
              <div class="flex-input-text"><p>Lieu de rendez-vous</p>  <input type="text" v-model="rendezVous"/></div>
              <div class="flex-input-text"><p>Heure de départ</p>      <input type="text" v-model="heureDepart"/></div>
              <div class="flex-input-text"><p>Moyen de transport</p>   <input type="text" v-model="moyenTransport"/></div>
              <hr>
            </ion-text>
            <hr>
            <ion-text>
              <p>
                La ville de

                <ion-select
                    class="selectVille"
                    ref="selectVille"
                    :disabled="validated"
                    v-model="selectionVille"
                    slot="block"
                    interface="action-sheet"
                    cancelText="Annuler"
                    aria-label="Ville"
                    placeholder="Sélectionnez une ville"
                    @ionChange="handleChange($event, 0)"
                >
                  <ion-select-option v-for="ville in villes" :key="ville.id" :value="ville">{{ ville.data }}</ion-select-option>
                </ion-select>

                accueillera au Forum de l'Arc la 13e
                édition du Salon interjurassien de
                <ion-select
                    class="selectSalon"
                    ref="selectSalon"
                    :disabled="validated"
                    v-model="selectionSalon"
                    slot="block"
                    interface="action-sheet"
                    cancelText="Annuler"
                    aria-label="Ville"
                    placeholder="Sélectionnez le type"
                    @ionChange="handleChange($event, 1)"
                >
                  <ion-select-option v-for="salon in typeSalon" :key="salon.id" :value="salon">{{ salon.data }}</ion-select-option>
                </ion-select>
                du mercredi
                <ion-select
                    class="selectDateDeb small-select"
                    ref="selectDateDeb"
                    :disabled="validated"
                    v-model="selectionDateDeb"
                    slot="block"
                    interface="action-sheet"
                    cancelText="Annuler"
                    aria-label="Date de début"
                    placeholder="Date de début"
                    @ionChange="handleChange($event, 4)"
                >
                  <ion-select-option v-for="date in dateDeb" :key="date.id" :value="date">{{ date.data }}</ion-select-option>
                </ion-select>
                au dimanche
                <ion-select
                    class="selectDateFin small-select"
                    ref="selectDateFin"
                    :disabled="validated"
                    v-model="selectionDateFin"
                    slot="block"
                    interface="action-sheet"
                    cancelText="Annuler"
                    aria-label="Date de fin"
                    placeholder="Date de fin"
                    @ionChange="handleChange($event, 5)"
                >
                  <ion-select-option v-for="date in dateFin" :key="date.id" :value="date">{{ date.data }}</ion-select-option>
                </ion-select>
                Mars 2026.
                Durant cinq jours, des milliers de jeunes de ton âge et leurs
                parents pourront découvrir plus de
                <ion-select
                    class="selectMetiers small-select"
                    ref="selectMetiers"
                    :disabled="validated"
                    v-model="selectionMetiers"
                    slot="block"
                    interface="action-sheet"
                    cancelText="Annuler"
                    aria-label="Métiers"
                    placeholder="Nombre de métiers"
                    @ionChange="handleChange($event, 2)"
                >
                  <ion-select-option v-for="metier in nbMetiers" :key="metier.id" :value="metier">{{ metier.data }}</ion-select-option>
                </ion-select>
                métiers ou
                formations présentés sur
                <ion-select
                    class="selectStands small-select"
                    ref="selectStands"
                    :disabled="validated"
                    v-model="selectionStands"
                    slot="block"
                    interface="action-sheet"
                    cancelText="Annuler"
                    aria-label="Stands"
                    placeholder="Nombre de stands"
                    @ionChange="handleChange($event, 3)"
                >
                  <ion-select-option v-for="metier in nbStands" :key="metier.id" :value="metier">{{ metier.data }}</ion-select-option>
                </ion-select>
                stands. Partir à la découverte du Salon est une occasion unique
                de recueillir des informations sur les possibilités de formation qui s’offrent à toi dans notre région et de
                réfléchir à ton avenir professionnel. Sur les stands, les professions et les formations seront présentées
                de manière interactive et concrète par des apprenti·e·s, des étudiant·e·s et des professionnel·le·s.
                Ce sera l’occasion pour toi de leur poser des questions et d’obtenir de bonnes réponses
              </p>
            </ion-text>
          </ion-card-content>
        </div>
        <!--
        <ion-card-content>
          <ion-button :disabled="!isFormComplete" expand="block" fill="outline" @click="validate">Valider</ion-button>
        </ion-card-content>
        -->
      </ion-card>
    </ion-content>
  </ion-page>
</template>

<script>

import {
  IonPage,
  IonContent,
  IonCard,
  IonCardHeader,
  IonText,
  IonCardContent,
  IonSelect,
  IonSelectOption
} from '@ionic/vue'
import PageNavigation from "@/components/PageNavigation.vue";

export default {
  name: 'QuizTexteATrous',
  components: {
    PageNavigation,
    IonCardContent,
    IonPage,
    IonContent,
    IonText,
    IonCard,
    IonCardHeader,
    IonSelectOption,
    IonSelect
  },
  computed: {
    isFormComplete() {
      return (
          this.selectionVille &&
          this.selectionSalon &&
          this.selectionMetiers &&
          this.selectionStands &&
          this.selectionDateDeb &&
          this.selectionDateFin
      );
    },
  },
  mounted() {
    this.loadSelectionsFromLocalStorage();
  },
  data() {
    return {
      pageTitle: '1/4 Le Salon en quelques mots',
      buttonDisabled: true,

      selectionVille: null,
      selectionSalon: null,
      selectionMetiers: null,
      selectionStands: null,
      selectionDateDeb: null,
      selectionDateFin: null,

      validated: false,
      points: 0,

      reponseVille: 'Moutier',
      reponseSalon: 'la formation',
      reponseMetiers: '200',
      reponseStands: '76',
      reponseDateDeb: '4',
      reponseDateFin: '8',

      villes: [
        { id: 0, data: 'Delémont' },
        { id: 1, data: 'Saignelégier' },
        { id: 2, data: 'Moutier' },
      ],
      typeSalon: [
        { id: 0, data: 'l\'agriculture' },
        { id: 1, data: 'la formation' },
        { id: 2, data: 'l\'automobile' },
      ],
      nbMetiers: [
        { id: 0, data: '50' },
        { id: 1, data: '100' },
        { id: 2, data: '200' },
      ],
      nbStands: [
        { id: 0, data: '55' },
        { id: 1, data: '70' },
        { id: 2, data: '97' },
      ],
      dateDeb: [
        { id: 0, data: '9' },
        { id: 1, data: '4' },
        { id: 2, data: '28' },
      ],
      dateFin: [
        { id: 0, data: '14' },
        { id: 1, data: '3' },
        { id: 2, data: '8' },
      ]
    }
  },
  methods: {
    handleChange(event, index) {
      // Appelé lorsqu'un choix est sélectionné
      // Met à jour la réponse sélectionnée dans le store
      this.$store.commit('updateSelectedAnswers', {
        index: index,
        answer: event.target.value,
      })

      console.log('TEST');
      this.saveSelectionsToLocalStorage();
    },
    saveSelectionsToLocalStorage() {
      // Enregistrer les sélections dans le localStorage
      localStorage.setItem('selectionVille', JSON.stringify(this.selectionVille));
      localStorage.setItem('selectionSalon', JSON.stringify(this.selectionSalon));
      localStorage.setItem('selectionMetiers', JSON.stringify(this.selectionMetiers));
      localStorage.setItem('selectionStands', JSON.stringify(this.selectionStands));
      localStorage.setItem('selectionDateDeb', JSON.stringify(this.selectionDateDeb));
      localStorage.setItem('selectionDateFin', JSON.stringify(this.selectionDateFin));
    },
    loadSelectionsFromLocalStorage() {
      // Charger les sélections depuis le localStorage
      const storedSelectionVille = localStorage.getItem('selectionVille');
      const storedSelectionSalon = localStorage.getItem('selectionSalon');
      const storedSelectionMetiers = localStorage.getItem('selectionMetiers');
      const storedSelectionStands = localStorage.getItem('selectionStands');
      const storedSelectionDateDeb = localStorage.getItem('selectionDateDeb');
      const storedSelectionDateFin = localStorage.getItem('selectionDateFin');

      // Mettre à jour les données du composant avec les sélections stockées
      if (storedSelectionVille) {
        this.selectionVille = JSON.parse(storedSelectionVille);
      }
      if (storedSelectionSalon) {
        this.selectionSalon = JSON.parse(storedSelectionSalon);
      }
      if (storedSelectionMetiers) {
        this.selectionMetiers = JSON.parse(storedSelectionMetiers);
      }
      if (storedSelectionStands) {
        this.selectionStands = JSON.parse(storedSelectionStands);
      }
      if (storedSelectionDateDeb) {
        this.selectionDateDeb = JSON.parse(storedSelectionDateDeb);
      }
      if (storedSelectionDateFin) {
        this.selectionDateFin = JSON.parse(storedSelectionDateFin);
      }
    },
  },
}
</script>

<style scoped>

ion-card {
  box-sizing: border-box;
  margin: 0;
}

ion-card-header {
  margin-top: 80px;
}

ion-card-subtitle {
  font-weight: bold;
}

ion-select {
  display: inline-flex;
  width: 160px;
  border-bottom: solid 2px #e30613;
  height: 20px;
}

.small-select {
  width: 70px !important;
}

ion-text p {
  font-size: 1.1rem;
  line-height: 30px;
}

#corrige > span {
  font-size: 1.2rem;
  font-weight: bold;
}

.hourSelection {
  max-width: 100px;
}

.flex-input-text {
  & p {
    margin: .4em;
    font-weight: bold;
  }

  & input {
    display: flex;
    align-items: baseline;
  }
}

input {
  background: #f8f8f8;
  border: none;
  border-radius: 5px;
  padding: .2em 1em;

  border-bottom: solid 2px rgba(227, 6, 19, 0.60);

  &:focus {
    background: #f3f3f3;
    outline: none;
  }

  &:not([type="date"]) {
    width: 100%;
  }
}

</style>
